import { render, staticRenderFns } from "./TourstandingsTable.vue?vue&type=template&id=4fa77368&scoped=true"
import script from "./TourstandingsTable.vue?vue&type=script&lang=js"
export * from "./TourstandingsTable.vue?vue&type=script&lang=js"
import style0 from "./TourstandingsTable.vue?vue&type=style&index=0&id=4fa77368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa77368",
  null
  
)

export default component.exports